import { action } from 'satcheljs/lib/legacy';
import { logUsage } from 'owa-analytics';
export default action('showHideSubjectPicker')(function showHideSubjectPicker(viewState, isOpened, reason) {
    viewState.isPickerOpened = isOpened;
    logUsage('SubjectPicker.ShowHide', { isOpened: isOpened, reason: reason });
});
//# sourceMappingURL=showHideSubjectPicker.js.map